
import React from "react";
import { Clock } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { intermediateTierSchema } from "@/contexts/program-creation/types";

interface TrainingHistorySectionProps {
  form: UseFormReturn<z.infer<typeof intermediateTierSchema>>;
}

export default function TrainingHistorySection({ form }: TrainingHistorySectionProps) {
  return (
    <div className="space-y-5 mb-8">
      <div className="flex items-center gap-2 text-white/90 border-b border-white/20 pb-2">
        <Clock size={18} />
        <h4 className="font-medium">Training Experience</h4>
      </div>
      
      <FormField
        control={form.control}
        name="trainingHistory"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              How long have they been exercising consistently (at least 3x per week)?
            </FormLabel>
            <Select 
              value={field.value} 
              onValueChange={field.onChange}
              defaultValue="less_than_6_months"
            >
              <FormControl>
                <SelectTrigger className="bg-white/20 border-white/30 text-white">
                  <SelectValue placeholder="Less than 6 months" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="less_than_6_months">Less than 6 months</SelectItem>
                <SelectItem value="6_to_12_months">6–12 months</SelectItem>
                <SelectItem value="1_to_2_years">1–2 years</SelectItem>
                <SelectItem value="2_plus_years">2+ years</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
